import { render, staticRenderFns } from "./MyRecordsOffline.vue?vue&type=template&id=50e3ab20&scoped=true&"
import script from "./MyRecordsOffline.vue?vue&type=script&lang=js&"
export * from "./MyRecordsOffline.vue?vue&type=script&lang=js&"
import style0 from "./MyRecordsOffline.vue?vue&type=style&index=0&id=50e3ab20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e3ab20",
  null
  
)

export default component.exports